export enum NotificationTypesEnum {
	// events
	CongratsEventPublished = '6a05d8a9-43ed-4104-a27b-339ed85c3e0a',
	EventUpdated = '6a9739cb-8fab-fe74-b3e9-9ca5119bed4c',
	EventEnded = '739cb6a9-8fab-fe74-b3e9-d4c9ca5119be',
	HostedEventEnded = '0c503964-73c7-4842-8849-d482e17a578e',
	EventCanceled = '7741a9b9-8afb-47ef-9e3b-d9c45ac911eb',
	EventInstanceCanceled = 'a693efce-8276-49f6-841f-36cc18470b85',
	EventInvitationAccepted = 'ba064523-f7e8-4efc-9fd2-ac0b4548e749',
	EventInvitationDeclined = '10604c03-1e18-40e1-a278-3cd67cf6ddd8',
	UserJoinedEvent = '8f4de23c-0c7d-4710-a2a5-1b955ea689f7',
	UserMadeDonationForEvent = 'e7004062-3a4d-4251-92ba-44e6c60d2512',
	UserInvitedToEvent = '1a53ca57-42f5-4aef-b61e-6bf72ffc7ef9',
	UserAddedToEventInstanceFromWaitlist = '4c305f9d-2138-4283-af97-32027f04efb5',
	UserNotifiedEventSpotAvailable = '2d51da29-c4cd-4d45-a891-74046a592982',
	UserEventOrderRefunded = '02f1ec6b-706f-41c2-9095-fabf4364fb06',
	UserEventOrderNotRefunded = 'cbb2c68c-7c28-42af-b5e1-9cd8e9673774',
	UserHasPendingRefunds = '41c202f1-706f-ec6b-9095-fabf4364fb06',
	MembershipPaused = '550e8400-e29b-41d4-a716-446655440000',
	YouHaveReceivedTicket = '8d6cf79b-33f8-445e-80d2-257be3160991',

	// past events
	PastEventPublishedBySweatPal = 'ac0bba06-4efc-9fd2-f7e8-4548e7494523',

	// social connections
	NewMutualSubscription = 'd12b29e5-0005-4f35-aa8b-6a6f2e53d9e3',
	NewFollower = '46a104af-cf6a-4497-a623-c6630d944dbd',
	NewFollowerRequest = '33796aeb-f0cc-4029-8f73-977561945479',
	FollowRequestAccepted = 'a431ed04-8f11-457f-ba96-2d9e93d0599c',

	// interests
	NewSystemInterestCreated = 'ca2a13e5-c4b8-461b-b8b2-dc421bb58c6f',
	SystemInterestDeleted = '782ccd99-4a9b-40fc-b8c0-4bdd70f6ee50',

	// past events reactions (kudos)
	NewReactionToPastEvent = 'c84efe49-bc9e-40d4-b08e-eec979eb72b3',

	// chat
	NewJoinGroupChatRequest = '287ccd99-b8c0-4a9b-40fc-4bdd70f6e05e',
	JoinGroupChatRequestAccepted = '40fccd99-4a9b-b8c0-287c-4bdd70f6e05e',
	JoinGroupChatRequestDeclined = '4bdd70f6-b8c0-4a9b-40fc-e05e287ccd99',

	// community profiles
	NewCommunityProfileAdmin = '4a9bcd99-40fc-b8c0-e05e-4bdd70f6287c',

	// weekly
	SundaySweatSchedule = '3cbe61f9-3faf-4b89-a4ff-01c6fdf3c474',
	MondayFreshGoals = '88bfed52-d46c-40bb-b660-9b1734136917',
	ThursdayInspiringReads = '5535cdd7-ea06-4490-9b7c-46a6d47d4a8b',
	SundayWellness = '63b77ea1-91b4-495f-9fc3-23210d00f8c0',
	SundayPlanWorkout = 'f527d9a8-ee4e-470b-9b65-45bd2513697d',

	// followers
	HostYouFollowCreatedEvent = 'e3cac7b7-8ad0-4810-90c3-a0dc22e3a741',

	// journals
	NewJournalFromYourSubscription = 'c22f1345-9f2d-4b27-b21e-e23d4c05f7ae',

	// getstream feed
	NewCommentOnYourPost = 'a387fbb3-d71e-4690-b2c3-287c42ebbbf6',
	NewCommentNearYourComment = '5379fca0-3c4b-4b00-ab47-dace0823fb2d',
	NewReactionToYourPost = '4228e46e-48fa-482b-965a-96ebf05f6895',
	NewLikeOnYourComment = '80090467-88f5-4c12-8b96-aef603476326',
	NewReplyToYourComment = '57ecb004-f80d-426a-a17c-d53fe5120a28',
	NewLikeOnYourReply = '4559ec03-066a-4d79-bd51-ad2e501b6489',
	SomebodyMentionedYou = '08f8b843-c908-44b9-8596-9e8c75544d61',

	// event time notifications
	YourEventStartsIn24Hours = '02c0af96-df1c-4bd4-9252-599062710f76',
	YourEventStartsIn1Hour = 'aba38432-7a9e-4e0c-8eee-405facd139fa',
	EventYouAttendedStartsIn10Minutes = '28a8f9c1-b8d7-47e6-9925-95c7efd8c127',

	// Mailing
	PersonalizedMailing = '4a576ddb-c088-4f90-bbdb-ce4ee74fffb7',
	EventMassInvitation = 'be2ca0a7-df4b-4a19-af35-52f94284fe33',
	MarkdownNotification = '027dab0f-ba1d-46a9-a64f-dc798d9541bc',

	// event donation
	UserJoinedDonationBasedEvent = '4062e700-3a4d-4251-92ba-0d251244e6c6',

	// Challenges
	ChallengeStarted = 'f5a30138-9f3f-4929-bb86-aa003c6cf8ce',
	ChallengeWeekStarted = 'f5a30138-9f3f-4929-bb86-aa003c6cf8c1',
}
